import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoData, SeoService } from './seo.service';

const NOINDEX_PREFIXES = [
  '/dashboard',
  '/my-account',
  '/notifications',
  '/reset-password',
];

@Injectable({ providedIn: 'root' })
export class RouterSeoEffect {
  private started = false;

  constructor(
    private router: Router,
    private seo: SeoService,
  ) {}

  start(): void {
    if (this.started) return;
    this.started = true;

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event) => {
        const nav = event as NavigationEnd;
        this.applyFor(nav.urlAfterRedirects, this.currentSeoData());
      });

    setTimeout(() => {
      this.applyFor(this.router.url, this.currentSeoData());
    });
  }

  private currentSeoData(): SeoData {
    let route: ActivatedRouteSnapshot | null = this.router.routerState.snapshot.root;
    let data: SeoData = {};

    while (route) {
      const seo = route.data?.['seo'] as SeoData | undefined;
      if (seo) data = { ...data, ...seo };
      route = route.firstChild;
    }

    return data;
  }

  private applyFor(url: string, data: SeoData): void {
    const path = url.split('?')[0] || '/';
    const isProtected = NOINDEX_PREFIXES.some((p) => path.startsWith(p));

    const finalData: SeoData = {
      ...data,
      robots: data.robots ?? (isProtected ? 'noindex, nofollow' : undefined),
      canonicalPath: data.canonicalPath ?? path,
    };

    this.seo.apply(finalData);
  }
}
